import {
  Component,
  ViewChild,
  OnInit,
  Input,
  EventEmitter,
  Output,
} from "@angular/core";
import { NbPopoverDirective } from "@nebular/theme";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";

@Component({
  selector: "tya-autocomplete",
  templateUrl: "./tya-autocomplete.component.html",
  styleUrls: ["./tya-autocomplete.component.scss"],
})
export class TyaAutocompleteComponent implements OnInit {
  @ViewChild(NbPopoverDirective) popover: NbPopoverDirective;

  @Input() styleInput: {} = {};

  @Input() data: Partial<Array<{}>>;
  @Input() key: string;
  @Input() value: string;
  @Input() fullWidth: boolean = true;
  @Input() status: string = "basic";
  @Input() placeholder: string = "";
  @Input() nbPopoverPlacement: string = "top";
  @Input() warningContent: string = "Data entered incorrectly";
  @Input() isWarning: boolean = false;
  @Input() messageNoData: string = "No data";
  @Input() selectedIndex: number;
  @Output() valueChange = new EventEmitter<string>();

  isSelected = false;
  isErr = false;
  indexItemSelected: number;

  constructor() {}

  options: string[] = [];
  filteredOptions$: Observable<string[]>;

  @ViewChild("autoInput") input;

  ngOnInit() {
    for (let i = 0; i < this.data.length; i++) {
      this.options.push(this.data[i][this.value].toString());
    }

    this.filteredOptions$ = of(this.options);

    if (this.selectedIndex && this.selectedIndex >= 0) {
      this.onSelectionChange(this.selectedIndex);
    }
  }

  private filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options.filter((optionValue) =>
      optionValue.toLowerCase().includes(filterValue)
    );
  }

  getFilteredOptions(value: string): Observable<string[]> {
    return of(value).pipe(map((filterString) => this.filter(filterString)));
  }

  onChange() {
    this.filteredOptions$ = this.getFilteredOptions(
      this.input.nativeElement[this.value]
    );

    if (this.input.nativeElement[this.value]) {
      this.isSelected = true;
    } else {
      this.isSelected = false;
    }
  }

  checkErr() {
    if (this.isWarning) {
      if (this.isSelected) {
        this.isErr = true;
        this.popover.show();
      } else {
        this.isErr = false;
        this.popover.hide();
      }
    }
  }

  resetErr() {
    this.isErr = false;
    this.popover.hide();
  }

  onSelectionChange($event: number) {
    this.isErr = false;
    this.indexItemSelected = $event;
    this.filteredOptions$ = this.getFilteredOptions(
      this.data[$event][this.value]
    );
    this.input.nativeElement[this.value] = this.data[$event][this.value];
    this.valueChange.emit(this.data[$event][this.key]);
  }
}
